module.exports = __webpack_public_path__ + "img/qwfb.d02d55f5.png";